import React, { useCallback, useContext, useMemo } from 'react';
import BroadcastModal from '../../BroadcastModal';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import ListingContext from '../../../subrouters/Seller/subrouters/ListingDetailSeller/providers/Listing/Listing.context';
import DealContext from '../../../subrouters/Seller/subrouters/ListingDetailSeller/providers/Deal/Deal.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import BroadcastPulseCheckModal from '../../BroadcastPulseCheckModal';

export default function useBroadcast() {
  const [broadcastModal, broadcastModalRef] = useCallbackRef<ModalRef>(null);

  const { currentUser } = useContext(CurrentUserContext);
  const { dealRoom, leads } = useContext(ListingContext);
  const { colleagues } = useContext(DealContext);

  const [canSendBroadcastPulseCheck, canSendBroadcastMessage] = useMemo(() => {
    const currentUserAsColleague = (colleagues || []).find(
      ({ userId }) => userId === currentUser?._id,
    );

    return [!!currentUserAsColleague, !!currentUserAsColleague?.useMessaging];
  }, [colleagues, currentUser?._id]);

  const canSendBroadcast = useMemo(
    () => canSendBroadcastPulseCheck || canSendBroadcastMessage,
    [canSendBroadcastMessage, canSendBroadcastPulseCheck],
  );

  const openBroadcastModal = useCallback(() => {
    if (!canSendBroadcast) return;

    broadcastModal?.open();
  }, [broadcastModal, canSendBroadcast]);

  const RenderedBroadcastModal = useMemo(() => {
    if (!canSendBroadcast) return null;

    if (canSendBroadcastMessage)
      return (
        <BroadcastModal
          ref={broadcastModalRef}
          dealRoomId={dealRoom?._id}
          leads={leads}
        />
      );

    return (
      <BroadcastPulseCheckModal
        ref={broadcastModalRef}
        dealRoomId={dealRoom?._id}
        leads={leads}
      />
    );
  }, [
    broadcastModalRef,
    canSendBroadcast,
    canSendBroadcastMessage,
    dealRoom?._id,
    leads,
  ]);

  return {
    canSendBroadcastPulseCheck,
    canSendBroadcastMessage,
    RenderedBroadcastModal,
    openBroadcastModal,
  };
}
